import Profile from './Profile'
import __ProfileDetails from './ProfileDetails'

export const ProfileDetails = __ProfileDetails
export default Profile